class CustomMediaGallery extends MediaGallery {
  constructor() {
    super();

    
    let url_string = window.location.href;
    let url = new URL(url_string);
    let url_variant_data = url.searchParams.get("variant");
    const featured_media = this.sliderGallery.querySelector('.featured_media');
    if(featured_media) {
      const featured_media_id = featured_media.getAttribute('data-media-id');
      if(featured_media_id){
        this.setActiveMedia(featured_media_id);
      }
    }
  }

  setActiveMedia(mediaId) {
    let activeMedia = this.sliderGallery.querySelector(`[data-media-id="${mediaId}"]`);
    if (activeMedia?.checkVisibility() === false) {
      activeMedia = activeMedia.nextElementSibling;
    }
    if (activeMedia === null) return;

    activeMedia.scrollIntoView({
      block: 'start',
      behavior: theme.config.motionReduced ? 'auto' : 'smooth'
    });
  
    // 2column前提の処理　上までスクロール
    /*
    if(activeMedia.offsetTop == 0 && window.matchMedia('(min-width: 1024px)').matches) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      activeMedia.scrollIntoView({
        block: 'start',
        behavior: theme.config.motionReduced ? 'auto' : 'smooth'
      });
    }
    */
  }
}
customElements.define('custom-media-gallery', CustomMediaGallery);


class CustomMediaDots extends SliderDots {
  constructor() {
    super();
  }

  init() {
    super.init();
    this.resetIndexes();
    this.setFirstThumb();
  }

  resetIndexes() {
    let newIndex = 1;
    this.itemsToShow.forEach((item, index) => {
      item.setAttribute('data-index', newIndex);
      item.setAttribute('aria-current', index === 0 ? 'true' : 'false');

      newIndex++;
    });
  }

  setFirstThumb() {
    if(this.firstThumb) {
      const first_thumb_index = this.firstThumb.getAttribute('data-index');
      if(first_thumb_index) {
        super.transitionTo(parseInt(first_thumb_index) - 1);

        super.itemsToShow.forEach((item) => {
          item.setAttribute('aria-current', parseInt(item.getAttribute('data-index')) ===  parseInt(first_thumb_index) ? 'true' : 'false');
        });
      }
    }
  }

  get firstThumb() {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let url_variant_data = url.searchParams.get("variant");
    return this.querySelector('.featured_media_thumb');
  }
}
customElements.define('custom-media-dots', CustomMediaDots);